module.exports = __webpack_public_path__ + "img/8.59124d91.png";